import React, { useState } from 'react';

const faqs = [
  {
    question: 'Is MeetOcto suitable for teams and organizations?',
    answer: 'Yes! MeetOcto works for both individuals and teams. You can auto-assign meetings, see team availability, and keep everyone on the same page with team-wide scheduling pages.',
  },
  {
    question: 'Can I customize my booking page?',
    answer: 'Absolutely! You can add your photo, set your available hours, define buffer times, and include a short welcome message to make your booking page feel personal and professional.',
  },
  {
    question: 'How do I connect my calendar to MeetOcto?',
    answer: 'Simply link your Google Calendar or Outlook calendar, and MeetOcto will automatically sync your availability in real-time—no extra steps needed. Your bookings show up instantly.',
  },
  {
    question: 'Does MeetOcto send reminders to attendees?',
    answer: 'Yes! Automated email reminders are sent to attendees before their meetings. This helps reduce no-shows and keeps everyone informed.',
  },
  {
    question: 'Can I collect payments through MeetOcto?',
    answer: 'Yes, MeetOcto integrates with Stripe and PayPal so you can charge for your meetings, coaching sessions, or consultations directly through your booking page.',
  },
  {
    question: 'Is there a free plan?',
    answer: 'Yes. MeetOcto includes a Free plan with essential scheduling. No credit card is required to create your account.',
  },
  {
    question: 'Do paid plans include a trial?',
    answer: 'Yes. New signups can start a 14-day trial of Standard or Teams after adding a card. You will not be charged today. If you do not cancel, we charge the plan price after 14 days. Existing Free accounts that upgrade later are charged immediately. SMS reminders unlock after the trial converts to a paid subscription.',
  },
];

export const FaqsView = () => {
  const [openIndex, setOpenIndex] = useState(0);

  const toggle = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section id="faq" className="faq-section">
      <div className="faq-section__inner">
        <div className="faq-section__header">
          <span className="faq-section__label">Got Questions?</span>
          <h2 className="faq-section__title">Frequently Asked Questions</h2>
          <p className="faq-section__subtitle">
            Everything you need to know about MeetOcto. Can't find the answer? Reach out to our team.
          </p>
        </div>

        <div className="faq-list">
          {faqs.map((faq, index) => {
            const isOpen = openIndex === index;
            return (
              <div
                key={index}
                className={`faq-item${isOpen ? ' faq-item--open' : ''}`}
              >
                <button
                  className="faq-item__question"
                  onClick={() => toggle(index)}
                  aria-expanded={isOpen}
                >
                  <span>{faq.question}</span>
                  <span className="faq-item__icon">
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                      <path
                        d={isOpen ? 'M5 12.5l5-5 5 5' : 'M5 7.5l5 5 5-5'}
                        stroke="#0C4767"
                        strokeWidth="1.8"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </span>
                </button>
                {isOpen && (
                  <div className="faq-item__answer">
                    <p>{faq.answer}</p>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
